<ul class="breadcrumb">
  <li class="breadcrumb-item" *ngFor="let item of breadcrumList">
    <a class="breadcrumb-link"
      (click)="displayRightmenu(item?.menuId, item?.route, item?.type)">
      <!-- {{item?.label}} -->
      {{ translateLabel(item?.label) }}
    </a>
  </li>
</ul>